import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { getClerkInstance } from "@/init/clerk";
import DashboardView from "../views/dashboard/dashboard_view.vue";
import RegisterView from "../views/register_view.vue";
import LoginView from "../views/login_view.vue";
import ForgotPasswordView from "../views/forgot_password_view.vue";
import AccountView from "../views/account/account_view.vue";
import EssaysView from "../views/essays_view.vue";
import EssayView from "../views/essay_view.vue";
import EssayCompareView from "../views/essay_compare_view.vue";
import CanceledView from "../views/canceled_view.vue";
import SummarizeView from "../views/summarize_view.vue";
import AiDetectorView from "../views/ai_detector_view.vue";
import RubricsView from "../views/rubrics_view.vue";
import EditRubricView from "../views/edit_rubric_view.vue";
import PreviewRubricView from "../views/preview_rubric_view.vue";
import SupportView from "../views/support_view.vue";
import ClassesView from "../views/classes_view.vue";
import ClassView from "../views/class_view.vue";
import EditClassView from "../views/edit_class_view.vue";
import NewClassView from "../views/new_class_view.vue";

import AssignmentsView from "../views/assignments/assignments_view.vue";
import AssignmentView from "../views/assignments/assignment_view.vue";
import NewAssignmentView from "../views/assignments/new_assignment_view.vue";
import EditAssignmentView from "../views/assignments/edit_assignment_view.vue";

import UploadEssaysView from "../views/start-grading/upload_essays_view.vue";
import ImportClassroomView from "../views/imports/classroom_view.vue";
import ImportCanvasView from "../views/imports/canvas_view.vue";
import MetricsOverviewView from "../views/metrics/metrics_overview_view.vue";
import MetricsClassView from "../views/metrics/metrics_class_view.vue";
import MetricsAssignmentView from "../views/metrics/metrics_assignment_view.vue";
import MetricsCustomReportView from "../views/metrics/metrics_custom_report_view.vue";
import MetricsStudentView from "../views/metrics/metrics_student_view.vue";
import UsageDashboardView from "../views/usage-dashboard/usage_dashboard_view.vue";

import FreeToolGrade from "../views/free-tools/grade.vue";
import LetterOfRecommendation from "../views/free-tools/letter_of_recommendation.vue";
import TongueTwister from "../views/free-tools/tongue_twister.vue";
import RoiCalculator from "../views/free-tools/roi_calculator.vue";
import FreeToolsAiDetection from "../views/free-tools/ai_detection.vue";
import FreeToolsSummarize from "../views/free-tools/summarize.vue";

import PremiumTrial from "../views/premium_trial.vue";

import WorkspaceView from "../views/workspace/index.vue";
import AssignmentsForm from "@/views/dashboard/workspace-integration/assignments/assignments-form.vue";
import SchoologyConnectCallback from "@/views/dashboard/workspace-integration/schoology/schoology-connect-callback.vue";

const routes = [
  {
    path: "/",
    name: "dashboard",
    component: DashboardView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/register",
    name: "register",
    component: RegisterView,
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPasswordView,
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/account",
    name: "account",
    component: AccountView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/essays",
    name: "essays",
    component: EssaysView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/essay/:essayId",
    name: "essay",
    component: EssayView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/essay/compare/:id1/:id2",
    name: "essay-compare",
    component: EssayCompareView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/success",
    name: "success",
    redirect: "/",
  },
  {
    path: "/canceled",
    name: "canceled",
    component: CanceledView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/summarize",
    name: "summarize",
    component: SummarizeView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ai-detector",
    name: "ai-detector",
    component: AiDetectorView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rubrics",
    name: "rubrics",
    component: RubricsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rubric/new",
    redirect: (to) => {
      return {
        path: "/rubrics",
        query: { ...to.query, openCreateRubric: "true" },
      };
    },
  },
  {
    path: "/rubrics/:id",
    name: "preview-rubric",
    component: PreviewRubricView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rubric/edit/:id",
    name: "edit-rubric",
    component: EditRubricView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rubrics/shared/:slug",
    name: "shared-rubric",
    component: PreviewRubricView,
    meta: {
      isShareView: true,
    },
  },
  {
    path: "/support",
    name: "support",
    component: SupportView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/classes",
    name: "classes",
    component: ClassesView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/class/new",
    name: "new-class",
    component: NewClassView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/class/:id",
    name: "class",
    component: ClassView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/class/edit/:id",
    name: "edit-class",
    component: EditClassView,
    meta: {
      requiresAuth: true,
    },
  },

  // Assignments
  {
    path: "/assignments",
    name: "assignments",
    component: AssignmentsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/assignment/new",
    name: "new-assignment",
    component: NewAssignmentView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/assignment/:id",
    name: "assignment",
    component: AssignmentView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/assignment/edit/:id",
    name: "edit-assignment",
    component: EditAssignmentView,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/imports/google-classroom",
    name: "imports-google-classroom",
    component: ImportClassroomView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/imports/canvas",
    name: "imports-canvas",
    component: ImportCanvasView,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/imports/:platformKey/:id/assignments",
    name: "imports-assignments",
    component: AssignmentsForm,
    meta: {
      requiresAuth: true,
    },
  },

  // Insight (redirected to metrics)
  {
    path: "/insight",
    redirect: "/metrics",
  },

  // Metrics
  {
    path: "/metrics",
    redirect: () => {
      const clerk = getClerkInstance();
      const memberships = clerk?.user?.organizationMemberships ?? [];
      const membership = memberships[0];
      if (membership?.role === "org:admin") {
        return `/metrics/organization/${membership.organization.id}/overview`;
      }
      const clerkUserId =
        (store.default || store).state.clerkOrgContext.clerkUserId ?? "";
      return `/metrics/user/${clerkUserId}/overview`;
    },
  },
  // Legacy redirects
  {
    path: "/metrics/organization/:orgId",
    redirect: (to) => `/metrics/organization/${to.params.orgId}/overview`,
  },
  {
    path: "/metrics/organization/:orgId/user/:userId",
    redirect: (to) =>
      `/metrics/organization/${to.params.orgId}/user/${to.params.userId}/overview`,
  },
  {
    path: "/metrics/user/:userId",
    redirect: (to) => `/metrics/user/${to.params.userId}/overview`,
  },
  // Org admin routes
  {
    path: "/metrics/organization/:orgId/overview",
    name: "metrics-org",
    component: MetricsOverviewView,
    meta: { requiresAuth: true, noPadding: true },
  },
  {
    path: "/metrics/organization/:orgId/user/:userId/overview",
    name: "metrics-org-user",
    component: MetricsOverviewView,
    meta: { requiresAuth: true, noPadding: true },
  },
  {
    path: "/metrics/organization/:orgId/user/:userId/class/:classId",
    name: "metrics-org-class",
    component: MetricsClassView,
    meta: { requiresAuth: true, noPadding: true },
  },
  {
    path: "/metrics/organization/:orgId/user/:userId/class/:classId/assignment/:assignmentId",
    name: "metrics-org-assignment",
    component: MetricsAssignmentView,
    meta: { requiresAuth: true, noPadding: true },
  },
  {
    path: "/metrics/organization/:orgId/user/:userId/class/:classId/student/:studentId",
    name: "metrics-org-student",
    component: MetricsStudentView,
    meta: { requiresAuth: true, noPadding: true },
  },
  {
    path: "/metrics/organization/:orgId/user/:userId/custom-report",
    name: "metrics-org-custom-report",
    component: MetricsCustomReportView,
    meta: { requiresAuth: true, noPadding: true },
  },
  // Regular user routes
  {
    path: "/metrics/user/:userId/overview",
    name: "metrics-user",
    component: MetricsOverviewView,
    meta: { requiresAuth: true, noPadding: true },
  },
  {
    path: "/metrics/user/:userId/class/:classId",
    name: "metrics-user-class",
    component: MetricsClassView,
    meta: { requiresAuth: true, noPadding: true },
  },
  {
    path: "/metrics/user/:userId/class/:classId/assignment/:assignmentId",
    name: "metrics-user-assignment",
    component: MetricsAssignmentView,
    meta: { requiresAuth: true, noPadding: true },
  },
  {
    path: "/metrics/user/:userId/class/:classId/student/:studentId",
    name: "metrics-user-student",
    component: MetricsStudentView,
    meta: { requiresAuth: true, noPadding: true },
  },
  {
    path: "/metrics/user/:userId/custom-report",
    name: "metrics-user-custom-report",
    component: MetricsCustomReportView,
    meta: { requiresAuth: true, noPadding: true },
  },

  // Organization usage dashboard (org admins only)
  {
    path: "/organization/:orgId/usage-dashboard",
    name: "usage-dashboard",
    component: UsageDashboardView,
    meta: { requiresAuth: true, noPadding: true },
    beforeEnter: (to, from, next) => {
      const clerk = getClerkInstance();
      const memberships = clerk?.user?.organizationMemberships ?? [];
      const membership = memberships[0];
      const isAdmin = membership?.role === "org:admin";
      if (!isAdmin || membership.organization.id !== to.params.orgId) {
        next("/");
      } else {
        next();
      }
    },
  },

  // Free Tools
  {
    path: "/free-tools/grade",
    name: "free-tools-grade",
    component: FreeToolGrade,
    meta: {
      hideNavbar: true,
    },
  },

  {
    path: "/free-tools/letter-of-recommendation",
    name: "letter-of-recommendation",
    component: LetterOfRecommendation,
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/free-tools/tongue-twister",
    name: "tongue-twister",
    component: TongueTwister,
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/free-tools/roi-calculator",
    name: "roi-calculator-twister",
    component: RoiCalculator,
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/free-tools/ai-detection",
    name: "free-tools-ai-detection",
    component: FreeToolsAiDetection,
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/free-tools/summarize",
    name: "free-tools-summarize",
    component: FreeToolsSummarize,
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/premium-trial",
    name: "premium-trial",
    component: PremiumTrial,
  },
  {
    path: "/workspace/:workspaceKey/:id",
    name: "workspace",
    component: WorkspaceView,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/workspace/:workspaceKey/:id/essay",
    name: "workspace-essay-upload",
    component: UploadEssaysView,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/grading/manual-upload",
    name: "manual-grading",
    component: UploadEssaysView,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/workspace/:workspaceKey/:id/essay/:essayId",
    name: "workspace-essay-view",
    component: EssayView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schoology/connect",
    name: "schoology-connect",
    component: SchoologyConnectCallback,
    meta: {
      requiresAuth: true,
    },
  },

  // SSO Callback, special for custom SSO providers (Canvas)
  {
    path: "/sso-callback",
    name: "sso-callback",
    component: {
      render: (h) => h("div", { class: "p-4" }, "Processing..."),
      created() {
        const clerk = this.$getClerk();

        // if (clerk.client.signIn.id && !clerk.client.signUp?.id) {
        //   clerk.client.signUp.create({ transfer: true });
        //   clerk.checkStatus({ clientProvider: clerk.client.signUp });
        // } else {
        //   console.log("redirect");
        // }
        const verifyEmailAddressUrl = `${window.location.origin}/verify-email`;
        const customNavigate = async (url) => {
          // ignore navigate if it's the verify email address page (override inside app)
          if (url.includes(verifyEmailAddressUrl)) {
            const emailAddressVerifications =
              clerk.client.signUp.verifications.emailAddress;

            if (
              emailAddressVerifications.nextAction === "needs_attempt" &&
              emailAddressVerifications.strategy === "from_oauth_custom_canvas"
            ) {
              await clerk.client.signUp.prepareEmailAddressVerification({
                strategy: "email_code",
              });
              // this.$bvModal.show("verify-email-modal");
              window.location.href = "/register#/verify-email-address";
              return;
            }

            return;
          }

          window.location.href = url;
        };
        clerk.handleRedirectCallback(
          {
            verifyEmailAddressUrl,
          },
          customNavigate
        );
      },
    },
  },
  {
    path: "*",
    redirect: "/login",
  },
];

let router = null;

export function initRouter() {
  Vue.use(VueRouter);
  router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  router.beforeEach((to, from, next) => {
    const clerk = getClerkInstance();
    const isAuthenticated = clerk?.user;

    if (!isAuthenticated) {
      if (to.meta.requiresAuth) {
        next("/login");
      } else {
        next();
      }
    } else {
      const user = (store.default || store).state.user;

      if (
        (user?.showQuiz && to?.name !== "dashboard") ||
        to.name === "login" ||
        to.name === "register"
      ) {
        next("/");
      } else {
        next();
      }
    }
  });

  router.afterEach(() => {
    Vue.prototype.$egModal?.hideAll();
  });

  // Add this error handler to suppress duplicate navigation errors
  const originalPush = router.push;
  router.push = function push(location) {
    return originalPush.call(this, location).catch((err) => {
      if (err.name !== "NavigationDuplicated") {
        // Only rethrow if it's not a navigation duplication
        throw err;
      }
      // Otherwise silently ignore the error
    });
  };

  return router;
}

export default router;
